import React from 'react';

export const NotFound = () => { 
    return <h1>Not Found!</h1>;
};
